export const MenuList = [
  //Dashboard
  {
    title: "Dashboard",
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-dashboard-1" />,
    to: "dashboard",
    content: [
      {
        title: "Dashboard",
        to: "dashboard",
      },

      // {
      //   title: "Analytics",
      //   to: "analytics",
      // },
      // {
      //   title: "Review",
      //   to: "review",
      // },
      // {
      //   title: "Order List",
      //   to: "order-list",
      // },
      // {
      //   title: "Customer",
      //   to: "customer-list",
      // },
      // {
      //   title: "Task",
      //   to: "task",
      // },
    ],
  },
  {
    title: "Editor Page",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-pencil" />,
    to: "editor-page",
    content: [
      {
        title: "Editor Page",
        to: "editor-page",
      },
    ],
  },
  {
    title: "Home Page",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-house-user" />,
    to: "home-page",
    content: [
      {
        title: "Home Page Content",
        to: "home-page",
      },
    ],
  },
  {
    title: "Country",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="flaticon-381-controls-5" />,
    to: "country",
    content: [
      {
        title: "Country",
        to: "country",
      },
      {
        title: "Add Country",
        to: "add-country",
      },
    ],
  },

  {
    title: "Questions",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-lightbulb" />,
    to: "questions",
    content: [
      {
        title: "Questions",
        to: "questions",
      },
      {
        title: "Add Question",
        to: "add-question",
      },
    ],
  },

  {
    title: "User Attempts",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-user-pen" />,
    to: "user-attempts",
    content: [
      {
        title: "User Attemps",
        to: "user-attempts",
      },
    ],
  },

  {
    title: "Blog",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fa-solid fa-file-lines" />,
    to: "blog",
    content: [
      {
        title: "Blog",
        to: "blog",
      },
      {
        title: "Add Blog",
        to: "add-blog",
      },
    ],
  },
  //Customer Reviews
  {
    title: "Customer's Review",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-users"></i>,
    to: "customer-review",
    content: [
      {
        title: "Customer's Review",
        to: "customer-review",
      },
      {
        title: "Add Customer's Review",
        to: "add-customer-review",
      },
    ],
  },

  //success story
  {
    title: "Success Story",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-trophy"></i>,
    to: "success-story",
    content: [
      {
        title: "Success Story",
        to: "success-story",
      },
      {
        title: "Add Success Story",
        to: "add-success-story",
      },
    ],
  },

  //faq
  {
    title: "Faq",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fa fa-question-circle"></i>,
    to: "faq",
    content: [
      {
        title: "Faq",
        to: "faq",
      },
      {
        title: "Add Faq",
        to: "add-faq",
      },
    ],
  },

  //Study programs
  {
    title: "Study Program",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-graduation-cap"></i>,
    to: "study-program",
    content: [
      {
        title: "Study Program",
        to: "study-program",
      },
      {
        title: "Add Study Program",
        to: "add-study-program",
      },
    ],
  },

  // Jobs
  {
    title: "Job",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-briefcase"></i>,
    to: "job",
    content: [
      {
        title: "Job",
        to: "job",
      },
      {
        title: "Add Job",
        to: "add-job",
      },
    ],
  },

  //Accommodation Detail
  // {
  //   title: "Accommodation Detail",
  //   // update : 'New',
  //   classsChange: "mm-collapse",
  //   iconStyle: <i className="fas fa-house-user"></i>,
  //   to: "accommodation-detail",
  //   content: [
  //     {
  //       title: "Accommodation Detail",
  //       to: "accommodation-detail",
  //     },
  //     {
  //       title: "Add Accommodation Detail",
  //       to: "add-accommodation-detail",
  //     },
  //   ],
  // },

  //Forex Order
  {
    title: "Forex Order",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-receipt"></i>,
    to: "order",
    content: [
      {
        title: "Forex Order",
        to: "order",
      },
    ],
  },

  //Contact Form Entries
  {
    title: "Contact Form Entries",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-comment-dots"></i>,
    to: "contact-form-entry",
    content: [
      {
        title: "Contact Form Entries",
        to: "contact-form-entry",
      },
    ],
  },

  //Users
  {
    title: "User",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-user"></i>,
    to: "user",
    content: [
      {
        title: "User",
        to: "user",
      },
    ],
  },

  //Scraper
  {
    title: "AI App Scraper",
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-spider"></i>,
    to: "scraper",
    content: [
      {
        title: "AI App Scraper",
        to: "scraper",
      },
    ],
  },

  //Users
  {
    title: "Settings",
    // update : 'New',
    classsChange: "mm-collapse",
    iconStyle: <i className="fas fa-cog"></i>,
    to: "settings",
    content: [
      {
        title: "Settings",
        to: "settings",
      },
    ],
  },
];
